import { FC, useMemo } from "react";
import orderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableHelper from "./order-optimizer-raily-details-hidden-details-heading-tables-driver-table.helper";
import OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableRow from "../types/order-optimizer-raily-details-hidden-details-center-tables-driver-table-row";
import TableComponent, {
  TableProps,
} from "../../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../../context/app.context";
import { OrderOptimizerRailyDetailsItemStepsOrdersPoints } from "../../../common/types/order-optimizer-raily-details-item";
import orderOptimizerRailyDetailsHelper from "../../../order-optimizer-raily-details.helper";

type OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableProps = Pick<
  TableProps,
  "isError" | "isLoading"
> & {
  detailsStepsOrdersPointsItems: OrderOptimizerRailyDetailsItemStepsOrdersPoints[];
};

const OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableComponent: FC<
  OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const createTableRow = (
    detailsStepsOrdersPointsItem: OrderOptimizerRailyDetailsItemStepsOrdersPoints,
  ): OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableRow => {
    const driverTimeLabel = orderOptimizerRailyDetailsHelper.getTimeLabel(
      detailsStepsOrdersPointsItem.driverTime,
    );
    const driverTimeTitle = orderOptimizerRailyDetailsHelper.getTimeLabel(
      detailsStepsOrdersPointsItem.driverTime,
    );

    const driverDistanceLabel =
      orderOptimizerRailyDetailsHelper.getDistanceLabel(
        detailsStepsOrdersPointsItem.driverDistance,
      );
    const driverDistanceTitle =
      orderOptimizerRailyDetailsHelper.getDistanceLabel(
        detailsStepsOrdersPointsItem.driverDistance,
      );

    const driverDrivingTimeLabel =
      orderOptimizerRailyDetailsHelper.getTimeDeltaLabel(
        detailsStepsOrdersPointsItem.driverDrivingTime,
      );
    const driverDrivingTimeTitle =
      orderOptimizerRailyDetailsHelper.getTimeDeltaLabel(
        detailsStepsOrdersPointsItem.driverDrivingTime,
      );

    const driverHaltingTimeLabel =
      orderOptimizerRailyDetailsHelper.getTimeDeltaLabel(
        detailsStepsOrdersPointsItem.driverHaltingTime,
      );
    const driverHaltingTimeTitle =
      orderOptimizerRailyDetailsHelper.getTimeDeltaLabel(
        detailsStepsOrdersPointsItem.driverHaltingTime,
      );

    return {
      id: uuidService.generate(),
      value: {
        driverTime: <div title={driverTimeTitle}>{driverTimeLabel}</div>,
        driverDistance: (
          <div title={driverDistanceTitle}>{driverDistanceLabel}</div>
        ),
        driverDrivingTime: (
          <div title={driverDrivingTimeTitle!}>{driverDrivingTimeLabel}</div>
        ),
        driverHaltingTime: (
          <div
            title={driverHaltingTimeTitle!}
            className={
              detailsStepsOrdersPointsItem.driverHaltingTime < 0
                ? "time_delayed"
                : ""
            }
          >
            {driverHaltingTimeLabel}
          </div>
        ),
      },
    };
  };

  const rows: OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableRow[] =
    useMemo(() => {
      return props.detailsStepsOrdersPointsItems.map(createTableRow);
    }, [props.detailsStepsOrdersPointsItems, selectedAppLanguage]);
  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
      noHeader
    />
  );
};

export default OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableComponent;
